import { Trans, useTranslation } from 'react-i18next';
import LocationSection2Image1 from '../../assets/location_section2_image1.png';
import LocationSection2Image2 from '../../assets/location_section2_image2.png';
import LocationSection2Image3 from '../../assets/location_section2_image3.png';
import LocationSection2Image4 from '../../assets/location_section2_image4.png';
import theme from '../../common/color/theme';
import { HorizontalEqualLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H7, Text4 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import BTButton from '../../common/components/BTButton';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const LocationSection2 = () => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();

  const openAddress1 = () => {
    const url = `https://map.naver.com/p/entry/place/13149068?c=15.00,0,0,0,dh&placePath=/home?from=map&fromPanelNum=1&additionalHeight=76&timestamp=202508112311&locale=ko&svcName=map_pcv5`;
    const win = window.open(url, '_blank');
    if (!win) {
      alert("팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.");
    }
  }

  const openAddressHyang = () => {
    const url = `https://map.naver.com/p/entry/place/1539331295?c=15.00,0,0,0,dh&placePath=/home?from=map&fromPanelNum=1&additionalHeight=76&timestamp=202508112314&locale=ko&svcName=map_pcv5`;
    const win = window.open(url, '_blank');
    if (!win) {
      alert("팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.");
    }
  }

  const openAddressYang = () => {
    const url = `https://map.naver.com/p/entry/place/1618309056?c=15.00,0,0,0,dh&placePath=/home?from=map&fromPanelNum=1&additionalHeight=76&timestamp=202508112315&locale=ko&svcName=map_pcv5`;
    const win = window.open(url, '_blank');
    if (!win) {
      alert("팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.");
    }
  }

  const openAddressHwa = () => {
    const url = `https://map.naver.com/p/entry/place/2001334593?c=15.00,0,0,0,dh&placePath=/home?from=map&fromPanelNum=1&additionalHeight=76&timestamp=202508200010&locale=ko&svcName=map_pcv5`;
    const win = window.open(url, '_blank');
    if (!win) {
      alert("팝업이 차단되었습니다. 브라우저 설정을 확인해주세요.");
    }
  }

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : pxToRem(166)} />
      <img src={LocationSection2Image1} style={{ width: '100%' }} />
      <BTBox height={isMobile ? 15 : pxToRem(40)} />
      {isMobile ? (
        <VerticalLayout >
          <H7 style={{ flex: 0.34, whiteSpace: 'nowrap' }}>{t('본사')}</H7>
          <BTBox height={4} />
          <VerticalLayout style={{ flex: 0.66 }}>
            <HorizontalLayout style={{ alignItems: 'center' }}>
              <Text4 style={{ opacity: '0.5', flex: 1 }}><Trans i18nKey='경기도 수원시 권선구 서부로 1433-80' /></Text4>
              <BTButton width='50px' height='20px'
                color='white'
                textColor='#464646'
                borderColor='#979797'
                hoverBorderColor={theme.colors.BIBI}
                hoverColor={theme.colors.BIBI}
                hoverTextColor='#ffffff'
                sx={{
                  fontSize: '9px',
                  borderRadius: '5px',
                  paddingInline: '6px',
                  paddingBlock: 0,
                }} onClick={() => openAddress1()} data-analytics-name="본사_지도보기"><Trans i18nKey='지도보기' /></BTButton>
            </HorizontalLayout>
            <Text4 style={{ opacity: '0.5' }}>{t('전화번호')} : 031-8009-0777</Text4>
            <Text4 style={{ opacity: '0.5' }}>{t('팩스번호')} : 031-8009-0778</Text4>
          </VerticalLayout>
        </VerticalLayout>
      ) : (
        <HorizontalLayout style={{ alignItems: 'start' }}>
          <H7 style={{ whiteSpace: 'nowrap' }}>{t('본사')}</H7>
          <BTBox width={pxToRem(1000)} />
          <VerticalLayout>
            <HorizontalLayout wrapContents={true} style={{ alignItems: 'center' }}>
              <Text4 style={{ opacity: '0.5', whiteSpace: 'nowrap' }}>
                <Trans i18nKey='경기도 수원시 권선구 서부로 1433-80' />
              </Text4>

              <BTBox width={10}/>

              <BTButton
                width='auto'
                height='32px'
                color='white'
                textColor='#464646'
                borderColor='#979797'
                hoverBorderColor={theme.colors.BIBI}
                hoverColor={theme.colors.BIBI}
                hoverTextColor='#ffffff'
                sx={{
                  fontSize: '14px',
                  borderRadius: '8px',
                  px: '16px',          // 좌우 14px 패딩
                  whiteSpace: 'nowrap', // 버튼 글자 줄바꿈 방지
                  alignSelf: 'flex-start',
                }}
                onClick={() => openAddress1()}
                data-analytics-name="본사_지도보기"
              >
                <Trans i18nKey='지도보기' />
              </BTButton>
            </HorizontalLayout>

            <Text4 style={{ opacity: '0.5' }}>{t('전화번호')} : 031-8009-0777</Text4>
            <Text4 style={{ opacity: '0.5' }}>{t('팩스번호')} : 031-8009-0778</Text4>
          </VerticalLayout>
          <VerticalLayout />
        </HorizontalLayout>
      )}

      <BTBox height={isMobile ? 40 : pxToRem(200)} />

      {isMobile ? (
        <VerticalLayout>
          <img src={LocationSection2Image3} style={{ width: '100%' }} />
          <BTBox height={15} />
          <H7>{t('양감공장')}</H7>
          <BTBox height={4} />
          <HorizontalLayout style={{ alignItems: 'center' }}>
            <Text4 style={{ opacity: '0.5', flex: 1 }}>{t('경기도 화성시 양감면 개월안길 150')}</Text4>
            <BTButton width='50px' height='20px'
              color='white'
              textColor='#464646'
              borderColor='#979797'
              hoverBorderColor={theme.colors.BIBI}
              hoverColor={theme.colors.BIBI}
              hoverTextColor='#ffffff'
              sx={{
                fontSize: '9px',
                borderRadius: '5px',
                paddingInline: '6px',
                paddingBlock: 0,
              }}
              onClick={() => openAddressYang()} data-analytics-name="양감공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
          </HorizontalLayout>
          <BTBox height={40} />
          <img src={LocationSection2Image4} style={{ width: '100%' }} />
          <BTBox height={15} />
          <H7>{t('화성공장')}</H7>
          <BTBox height={4} />
          <HorizontalLayout style={{ alignItems: 'center' }}>
            <Text4 style={{ opacity: '0.5', flex: 1 }}><Trans i18nKey='경기도 화성시 서신면 전곡산단 10길 35' /></Text4>
            <BTButton width='50px' height='20px'
              color='white'
              textColor='#464646'
              borderColor='#979797'
              hoverBorderColor={theme.colors.BIBI}
              hoverColor={theme.colors.BIBI}
              hoverTextColor='#ffffff'
              sx={{
                fontSize: '9px',
                borderRadius: '5px',
                paddingInline: '6px',
                paddingBlock: 0,
              }} onClick={() => openAddressHwa()} data-analytics-name="화성공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
          </HorizontalLayout>
          <BTBox height={40} />
          <img src={LocationSection2Image2} style={{ width: '100%' }} />
          <BTBox height={15} />
          <H7>{t('향남공장')}</H7>
          <BTBox height={4} />
          <HorizontalLayout style={{ alignItems: 'center' }}>
            <Text4 style={{ opacity: '0.5', flex: 1, lineHeight: '24px' }}><Trans i18nKey='경기도 화성시 향남읍 토성로 464-17' /></Text4>
            <BTButton width='50px' height='20px'
              color='white'
              textColor='#464646'
              borderColor='#979797'
              hoverBorderColor={theme.colors.BIBI}
              hoverColor={theme.colors.BIBI}
              hoverTextColor='#ffffff'
              sx={{
                fontSize: '9px',
                borderRadius: '5px',
                paddingInline: '6px',
                paddingBlock: 0,
              }} onClick={() => openAddressHyang()} data-analytics-name="향남공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
          </HorizontalLayout>
        </VerticalLayout>
      ) : (
        <HorizontalEqualLayout gap={pxToRem(32)} style={{ alignItems: 'start' }}>
          <VerticalLayout>
            <img src={LocationSection2Image2} style={{ width: '100%' }} />
            <BTBox height={15} />
            <H7>{t('향남공장')}</H7>
            <BTBox height={10} />
            <HorizontalLayout wrapContents={true} style={{ alignItems: 'center' }}>
              <Text4 style={{ opacity: '0.5', flex: 1 }}><Trans i18nKey='경기도 화성시 향남읍 토성로 464-17' /></Text4>
              <BTBox width={10} />
              <BTButton width='auto' height='32px'
                color='white'
                textColor='#464646'
                borderColor='#979797'
                hoverBorderColor={theme.colors.BIBI}
                hoverColor={theme.colors.BIBI}
                hoverTextColor='#ffffff'
                sx={{
                  fontSize: '14px',
                  borderRadius: '8px',
                  px: '16px',          // 좌우 14px 패딩
                  whiteSpace: 'nowrap', // 버튼 글자 줄바꿈 방지
                  alignSelf: 'flex-start',
                }} onClick={() => openAddressHyang()} data-analytics-name="향남공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
            </HorizontalLayout>
          </VerticalLayout>
          <VerticalLayout>
            <img src={LocationSection2Image3} style={{ width: '100%' }} />
            <BTBox height={15} />
            <H7>{t('양감공장')}</H7>
            <BTBox height={10} />
            <HorizontalLayout wrapContents={true} style={{ alignItems: 'center' }}>
              <Text4 style={{ opacity: '0.5', flex: 1 }}>{t('경기도 화성시 양감면 개월안길 150')}</Text4>
              <BTBox width={10} />
              <BTButton width='auto' height='32px'
                color='white'
                textColor='#464646'
                borderColor='#979797'
                hoverBorderColor={theme.colors.BIBI}
                hoverColor={theme.colors.BIBI}
                hoverTextColor='#ffffff'
                sx={{
                  fontSize: '14px',
                  borderRadius: '8px',
                  px: '16px',          // 좌우 14px 패딩
                  whiteSpace: 'nowrap', // 버튼 글자 줄바꿈 방지
                  alignSelf: 'flex-start',
                }}
                onClick={() => openAddressYang()} data-analytics-name="양감공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
            </HorizontalLayout>
          </VerticalLayout>
          <VerticalLayout>
            <img src={LocationSection2Image4} style={{ width: '100%' }} />
            <BTBox height={15} />
            <H7>{t('화성공장')}</H7>
            <BTBox height={10} />
            <HorizontalLayout wrapContents={true} style={{ alignItems: 'center' }}>
              <Text4 style={{ opacity: '0.5', flex: 1 }}><Trans i18nKey='경기도 화성시 서신면 전곡산단 10길 35' /></Text4>
              <BTBox width={10} />
              <BTButton width='auto' height='32px'
                color='white'
                textColor='#464646'
                borderColor='#979797'
                hoverBorderColor={theme.colors.BIBI}
                hoverColor={theme.colors.BIBI}
                hoverTextColor='#ffffff'
                sx={{
                  fontSize: '14px',
                  borderRadius: '8px',
                  px: '16px',          // 좌우 14px 패딩
                  whiteSpace: 'nowrap', // 버튼 글자 줄바꿈 방지
                  alignSelf: 'flex-start',
                }} onClick={() => openAddressHwa()} data-analytics-name="화성공장_지도보기"><Trans i18nKey='지도보기' /></BTButton>
            </HorizontalLayout>
          </VerticalLayout>
        </HorizontalEqualLayout>
      )}

      <BTBox height={isMobile ? 117 : pxToRem(335)} />
    </VerticalLayout>
  );
};

export default LocationSection2;
